import { $$ } from 'utils/dom';
import { fadeInFromBottom } from '../animations';

export const storyVideo = () => {
  const storyVideos = $$('.story-video');

  if (storyVideos.length) {
    storyVideos.forEach(item => {
      fadeInFromBottom([item]);
    });
  }
};
